module.exports = __webpack_public_path__ + "static/media/naturally-well-logo.40413b37.png";